import { render, staticRenderFns } from "./AmazeDialog.vue?vue&type=template&id=00cc9a16&scoped=true"
import script from "./AmazeDialog.vue?vue&type=script&lang=js"
export * from "./AmazeDialog.vue?vue&type=script&lang=js"
import style0 from "./AmazeDialog.vue?vue&type=style&index=0&id=00cc9a16&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00cc9a16",
  null
  
)

export default component.exports